export const NAME = 'sso';
